import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Artifactory extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M11.9615929,1.71539809 L11.9615929,1.71539809 C9.02378685,1.71482552 6.37495095,3.48411426 5.25037052,6.19815621 C4.12579008,8.91219815 4.74696251,12.0364355 6.82420388,14.1138794 C8.90144525,16.1913233 12.025622,16.8128003 14.7397736,15.6884845 C17.4539252,14.5641686 19.2234721,11.9155052 19.2231858,8.97769912 C19.2185051,4.96905783 15.9702337,1.72046973 11.9615929,1.71539809 M11.9615929,17.9553982 C7.00334661,17.9553982 2.98389381,13.9359454 2.98389381,8.97769912 C2.98389381,4.01945281 7.00334661,-1.77635684e-15 11.9615929,-1.77635684e-15 C16.9198392,-1.77635684e-15 20.939292,4.01945281 20.939292,8.97769912 C20.9338296,13.933681 16.9175749,17.9499358 11.9615929,17.9553982 L11.9615929,17.9553982 Z M22.5038938,23.9299115 L1.5,23.9299115 L1.5,22.3164602 L22.5038938,22.3164602 L22.5038938,23.9299115 Z" />
      </svg>
    );
  }
}

export default Artifactory;
